const name = 'circle-k';

const contents = '<path fill="#FFF" d="M42.614 55h-7.209L24.717 40.749l10.771-13.92h6.794L31.18 40.5zM24.551 55h-5.634V26.829h5.634z"/>';

/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'K',
};

export default icon;
